import { IReportDefinition, IReportDefinitionType } from 'es/app/business-logic/domain-models/Reports';
import EntityStore from 'es/app/store/EntityStore';
import { computed, makeObservable, observable } from 'mobx';

export default class ReportStore extends EntityStore<IReportDefinition> {
    constructor() {
        super();
        makeObservable(this, {
            reports: computed,
            reportTypes: observable
        });
    }
    
    public get reports(): IReportDefinition[] {
        return this.entities;
    }

    public reportTypes: IReportDefinitionType[] = [];
}